import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this.toast = new bootstrap.Toast(this.element, {animation: true, autohide: true})
        this.toast.show()
        this.element.addEventListener("hidden.bs.toast", () => this.element.remove())
    }

}
